import { Expose } from "class-transformer";
import { PlanningBoardAbsenceTypeEnum } from "@/core/features/planning-boards/planning-board-absence-type.enum";

export class AssignPlanningBoardVacationDto {
  @Expose()
  userId: string;

  @Expose()
  type: PlanningBoardAbsenceTypeEnum;
}
